import React, {Component} from 'react'
import Product from "./product";
import {getPicturePathSmallImage} from "../util/CommonUtils"

class ProductContainer extends Component {
    state = {};

    picturePath(item) {
        return getPicturePathSmallImage(item.Category, item.Company, item.Name);
    }

    getDetailsURL = (category, company, itemname, filter) => {
        let url = './details/?' + 'category=' + category + "&company=" + company + "&item=" + itemname;
        if (filter.searchText) {
            url = url + "&filter.searchText=" + filter.searchText;
        }
        if (filter.category) {
            url = url + "&filter.category=" + filter.category;
        }
        if (filter.company) {
            url = url + "&filter.company=" + filter.company;
        }
        return url;
    }

    render() {

        return <React.Fragment>

            <div className="main-container">
                <div data-testid="product-container" className="product-container">
                    {this.props.displayedProducts.filter(item => item.Company).map(item =>
                        <Product
                            itemname={item.Name}
                            category={item.Category}
                            image={this.picturePath(item)}
                            company={item.Company}
                            price={item.Value}
                            detailsURL={this.getDetailsURL(item.Category, item.Company, item.Name, this.props.currentFilter)}
                        >
                        </Product>
                    )
                    }

                </div>

            </div>


        </React.Fragment>
    }
}

export default ProductContainer;
